/**
 * WordPress dependencies
 */
export * from '@wordpress/editor';
